import React from 'react';
import classNames from 'classnames';
import SideNav from './SideNav';

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNav: React.FC<MobileNavProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="ecme-side-nav-overlay"
          onClick={onClose}
        />
      )}

      {/* Mobile Sidebar */}
      <div className={classNames('ecme-side-nav-mobile', { open: isOpen, closed: !isOpen })}>
        {/* Close Button */}
        <button
          className="ecme-side-nav-mobile-close"
          onClick={onClose}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Reuse SideNav content */}
        <SideNav />
      </div>
    </>
  );
};

export default MobileNav;
